module.exports = __webpack_public_path__ + "static/media/globe-africa.5bf96b0b.svg";